module.exports = __webpack_public_path__ + "banner-disputa360-desktop.png";